import { IdType } from 'epic/common-form/ReloadFormRequest';
import { useAppSelector } from 'hooks/useAppSelector';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { quoteBlotterFilterByQuoteIds } from 'state/blotters/quote';
import type { ThunkDispatch } from 'state/state.common';
import { SmartQuoteParsingResult } from 'state/workspaces/smart-quote/model';
import { getAllPromptResults } from 'state/workspaces/smart-quote/selectors';
import { openResultsInBatchWorkspaceThunk } from 'state/workspaces/smart-quote/thunks';
import { workspaceTabRepriceRequested } from 'state/workspaces/workspace.actions';

export function useRepriceQuotes() {
  const dispatch = useDispatch<ThunkDispatch>();
  const promptResults = useAppSelector(getAllPromptResults);

  const reloadInAdvanced = (rfqId: string, externalQuoteId?: string) => {
    const aiGeneratedFields = promptResults.find(result => result.rfqId === rfqId)?.aiGeneratedFields;
    dispatch(
      workspaceTabRepriceRequested(
        rfqId,
        IdType.QuoteId,
        rfqId,
        null,
        'static',
        true,
        undefined,
        externalQuoteId,
        true,
        aiGeneratedFields,
      ),
    );
  };

  const reloadInBatch = useCallback(
    (results: SmartQuoteParsingResult[]) => {
      dispatch(openResultsInBatchWorkspaceThunk(results));
    },
    [dispatch],
  );

  const openInQuoteBlotter = useCallback(
    (results: SmartQuoteParsingResult[]) => {
      const quoteIds = results.flatMap(({ externalQuoteId }) =>
        externalQuoteId !== undefined ? [externalQuoteId] : [],
      );
      dispatch(quoteBlotterFilterByQuoteIds(quoteIds));
    },
    [dispatch],
  );

  return { reloadInAdvanced, reloadInBatch, openInQuoteBlotter };
}
